import React from 'react'

import CategoryDetail from './Components/CategoryDetail'
import TreePanel from './Components/TreePanel'

import { SaveDialog } from './Components/Modals'
import PartDetail from './Components/Grid'

import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

import { Splitter } from '@progress/kendo-react-layout'
import './CategoryForms.scss'
import { getBaseURL } from '../GlobalComponents/URLs'

const TREE_URL = `${getBaseURL()}webapi/inventory/categorytree`
const INVENTORY_CATEGORY_ATTRIBUTE_URL = `${getBaseURL()}webapi/invtcategoryattribute/`
const CAT_SAVE_URL = `${getBaseURL()}webapi/invtcategoryattribute/update/`

const SAVE_SUCCESSFUL_TEXT = 'Saved Successfully'

function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />
}

const CategoryForms = () => {
    const [treeInfo, setTreeInfo] = React.useState(false)
    const [treeInfo2, setTreeInfo2] = React.useState(false)
    const [currentCategory, setCurrentCategory] = React.useState(false)
    const [grid, setGrid] = React.useState([[]])
    const [grid2, setGrid2] = React.useState([[]])
    const [ica, setICA] = React.useState([[]])
    const [refresh, setRefresh] = React.useState([])
    const [attributes, setAttributes] = React.useState([])
    const [alertText, setAlertText] = React.useState(false)
    const [refreshTree, setRefreshTree] = React.useState([])
    const [canWrite, setCanWrite] = React.useState(false)
    const [currentModal, setCurrentModal] = React.useState(null)
    const [loading, setLoading] = React.useState(true)
    const [treeReloaded, setTreeReloaded] = React.useState([])
    const categoryRef = React.useRef(null)
    const currentFetchRef = React.useRef(null)
    const partsRef = React.useRef({
        attributes: [],
        columns: [],
        grid: [],
        changedParts: {},
        loadedParts: {},
    })
    const [splitterInfo, setSplitterInfo] = React.useState([
        { size: '20%', min: '80px', resizable: true },
        {},
    ])
    const [nestedSplitterInfo, setNestedSplitterInfo] = React.useState([
        { size: '20%', resizable: true, collapsible: true },
        {},
    ])
    const onSplitterChange = (event) => {
        setSplitterInfo(event.newState)
    }

    const onNestedSplitterChange = (event) => {
        setNestedSplitterInfo(event.newState)
    }

    React.useEffect(() => {
        loadTree()
    }, [refreshTree])

    React.useEffect(() => {
        if (!currentCategory) {
            return
        }
        currentFetchRef.current = currentCategory
        let dataurl = INVENTORY_CATEGORY_ATTRIBUTE_URL + currentCategory
        setLoading(true)
        fetch(dataurl, { credentials: 'include' })
            .then((resp) => {
                // if no content
                if (resp.status === 204) {
                    return { InventoryCategoryAttribute: [], Attributes: [] }
                } else if (resp.ok) {
                    return resp.json()
                } else throw new Error('bad request ' + resp.statusText)
            })
            .then((json) => {
                if (currentFetchRef.current !== currentCategory) {
                    return
                }

                json.InventoryCategoryAttribute = json.InventoryCategoryAttribute || []
                json.InventoryCategoryAttribute = json.InventoryCategoryAttribute.sort((a, b) =>
                    a['Part Number'] < b['Part Number'] ? -1 : 1
                )
                let columns = []
                let newData = []

                // work out keys so PartKey isn't in there and Part Number and Mkt are like Attributes
                let keys = json.Attributes.sort((a, b) => a.GridColumn - b.GridColumn).map(
                    (x) => x.Title
                )
                keys = [
                    'Part Number',
                    'Mkt',
                    'Description',
                    'Web Enabled',
                    'Data Quality Index',
                    'Image',
                    ...keys,
                ] //, "Data Quality Last Reviewed"

                // if there is no ICA
                let showKeys = { 'Part Number': true, Mkt: true, Description: true }

                json.Attributes.forEach((x) => (showKeys[x.Title] = true))

                for (let i = 0; i < keys.length; i++) {
                    columns.push({ value: keys[i] })
                }
                newData.push(columns)
                for (let i = 0; i < json.InventoryCategoryAttribute.length; i++) {
                    // default row in empty ds
                    if (json.InventoryCategoryAttribute[i]['Part Number'] === '') continue
                    let newItem = []
                    for (let k = 0; k < keys.length; k++) {
                        if (json.InventoryCategoryAttribute[i][keys[k]] !== undefined) {
                            if (keys[k] === 'Image')
                                newItem.push({
                                    value: json.InventoryCategoryAttribute[i][keys[k]],
                                    partKey: json.InventoryCategoryAttribute[i]['Partkey'],
                                })
                            else if (keys[k] === 'Web Enabled') {
                                newItem.push({
                                    value: json.InventoryCategoryAttribute[i][keys[k]],
                                    VendorWebEnabled:
                                        json.InventoryCategoryAttribute[i]['Vendor Web Enabled'],
                                    Available: json.InventoryCategoryAttribute[i]['Available'],
                                    PLCK: json.InventoryCategoryAttribute[i][
                                        'Product Life Cycle Key'
                                    ],
                                })
                            } else {
                                newItem.push({ value: json.InventoryCategoryAttribute[i][keys[k]] })
                            }
                        } else {
                            newItem.push({ value: '' })
                        }
                    }
                    newData.push(newItem)
                }
                let InvtMastAttributes = []
                InvtMastAttributes.push({ item: -1, Title: 'Part Number' })
                InvtMastAttributes.push({ item: -1, Title: 'Mkt' })
                InvtMastAttributes.push({ item: -1, Title: 'Description' })
                InvtMastAttributes.push({ item: -1, Title: 'Web Enabled' })
                InvtMastAttributes.push({ item: -1, Title: 'Data Quality Index' })
                InvtMastAttributes.push({ item: -1, Title: 'Image' })
                let newAttributes = [...InvtMastAttributes, ...json.Attributes]
                setAttributes(newAttributes)
                partsRef.current.columns = newAttributes
                setGrid(newData)
                setGrid2([...json.InventoryCategoryAttribute])
                setICA(JSON.parse(JSON.stringify(json)))
                setLoading(false)
            })
            .catch((e) => {
                alert(e.message)
            })
    }, [currentCategory, refresh])
    const treeKidFnc = (tree, nodeId, fnc) => {
        let res = fnc(tree[nodeId].node)
        tree[nodeId].children.forEach((ele) => {
            res += treeKidFnc(tree, ele, fnc)
        })
        return res
    }

    const getItemFromIndex = (tree, index) => {
        let indices = index.split('_')
        let res
        let currentTree = tree
        indices.forEach((ind) => {
            res = currentTree[ind]
            if (!res) return false
            currentTree = res.items
        })
        if (indices.filter((x) => x === false).length > 0) return false
        return res
    }

    const makeTree = (tree, nodeId, selectedIds, expandedIds) => {
        let newItemCount = treeKidFnc(tree, nodeId, (node) => {
            return node.PartCount || 0
        })
        let thisNode = {
            text: (tree[nodeId].node.Name || 'No Name') + ` (${newItemCount})`,
            node: tree[nodeId].node,
        }
        let items =
            tree[nodeId].children &&
            tree[nodeId].children.map((childId) =>
                makeTree(tree, childId, selectedIds, expandedIds)
            )
        if (items) thisNode.items = items
        if (expandedIds.includes(thisNode.node.CategoryId)) thisNode.expanded = true
        if (selectedIds.includes(thisNode.node.CategoryId)) thisNode.selected = true
        return thisNode
    }

    const getSelectedExpandedIds = (tree) => {
        if (!tree) return { selected: [], expanded: [] }
        let selected = []
        let expanded = []
        let toVisit = [...tree]
        while (toVisit.length > 0) {
            let currentNode = toVisit.pop()
            currentNode.items.forEach((item) => toVisit.push(item))
            if (currentNode.expanded) expanded.push(currentNode.node.CategoryId)
            if (currentNode.selected) selected.push(currentNode.node.CategoryId)
        }
        return { selected, expanded }
    }

    const loadTree = async () => {
        try {
            let resp = await fetch(TREE_URL, { credentials: 'include' })
            if (!resp.ok) throw new Error('Log in to use app')
            setCanWrite(resp.headers.get('Authorized') === 'True')
            let json = await resp.json()

            json.CategoryTree.sort((a, b) => (a.Name < b.Name ? -1 : 1))
            // make tree with each node having the category info for the node and a list of children
            let tree = {}
            for (let i = 0; i < json.CategoryTree.length; i++) {
                // update node info
                if (!tree[json.CategoryTree[i].CategoryId])
                    tree[json.CategoryTree[i].CategoryId] = { children: [] }

                json.CategoryTree[i].Technologies = []
                json.CategoryTree[i].ExternalContent = {
                    Tags: { 'How To': [], 'Selection Guides': [] },
                    Posts: { 'How To': [], 'Selection Guides': [] },
                }
                json.CategoryTree[i].PreferredVendors = []

                tree[json.CategoryTree[i].CategoryId].node = json.CategoryTree[i]

                // update parent info
                if (tree[json.CategoryTree[i].ParentId]) {
                    tree[json.CategoryTree[i].ParentId].children.push(
                        json.CategoryTree[i].CategoryId
                    )
                } else {
                    // create tree node
                    tree[json.CategoryTree[i].ParentId] = {
                        children: [json.CategoryTree[i].CategoryId],
                    }
                }
            }
            json.CategoryTechnologies.forEach((ele) => {
                tree[ele.CategoryId].node.Technologies.push(ele.TechnologyKey)
            })
            json.CategoryExternalContent &&
                json.CategoryExternalContent.forEach((ele) => {
                    let { CategoryId, Section, ...info } = ele
                    if (info.Type === 'Tag')
                        tree[CategoryId] &&
                            tree[CategoryId].node.ExternalContent.Tags[Section].push({
                                value: ele.Value,
                            })
                    else if (info.Type === 'Post')
                        tree[CategoryId] &&
                            tree[CategoryId].node.ExternalContent.Posts[Section].push({
                                value: ele.Value,
                                OrderBy: ele.OrderBy,
                            })
                    else {
                        alert('Unexpected External Content')
                    }
                })
            // sort this ascending so they go into the tree in order
            json.CategoryPreferredVendors.sort((a, b) => (a.OrderBy < b.OrderBy ? -1 : 1))

            json.CategoryPreferredVendors.forEach((ele) => {
                let { CategoryId, ...info } = ele
                tree[CategoryId] &&
                    tree[CategoryId].node.PreferredVendors.push({
                        VENDID: info.VendorId,
                        OrderBy: info.OrderBy,
                    })
            })

            let topLevel = Object.values(tree).filter((ele) => {
                return ele.node && ele.node.ParentId === -1
            })
            let { selected, expanded } = getSelectedExpandedIds(treeInfo2)
            let actualTree = topLevel.map((topNode) => {
                return makeTree(tree, topNode.node.CategoryId, selected, expanded)
            })

            setTreeInfo(tree)
            setTreeInfo2(actualTree) //tree
            setTreeReloaded([])
        } catch (err) {
            alert(err)
            // window.location = "/"
        }
    }

    const canChangeCategory = () => {
        if (!currentCategory || !categoryRef.current) {
            return true
        }
        if (!canWrite) {
            return true
        }

        let payload = getCatSavePayload(currentCategory)
        return Object.entries(payload).every((ele) => Object.keys(ele[1]).length === 0)
    }

    const getCatSavePayload = (categoryId) => {
        if (!categoryRef) {
            alert('Error no categoryInfo saved')
            return
        }

        let newCategory = JSON.parse(JSON.stringify(categoryRef.current))
        let oldCategory = treeInfo[categoryId]?.node

        let changedCategory = {}
        for (let key in oldCategory) {
            // I made up Technologies field for other table -- ParentId will be changed by left side apis
            if (
                key !== 'PreferredVendors' &&
                key !== 'ExternalContent' &&
                key !== 'Technologies' &&
                key !== 'ParentId' &&
                oldCategory[key] !== newCategory[key]
            ) {
                changedCategory[key] = newCategory[key]
            }
        }
        if (newCategory.Image) changedCategory.Image = newCategory.Image

        let CategoryChanged = changedCategory
        let newTechnologies = []
        let CategoryTechnologyAdded = []
        let oldTechnologies = []
        let CategoryTechnologyDeleted = []
        if (newCategory?.Technologies && oldCategory?.Technologies) {
            newTechnologies = newCategory.Technologies.filter(
                (x) => !oldCategory.Technologies.includes(x)
            )

            CategoryTechnologyAdded = newTechnologies.map((x) => ({ TechnologyKey: x }))

            oldTechnologies = oldCategory.Technologies.filter(
                (x) => !newCategory.Technologies.includes(x)
            )

            CategoryTechnologyDeleted = oldTechnologies.map((x) => ({ TechnologyKey: x }))
        }

        let CategoryExternalContentAdded = []
        let Sections = ['How To', 'Selection Guides']
        Sections.forEach((section) => {
            let newPosts = newCategory.ExternalContent.Posts[section].filter(
                (newPost) =>
                    !oldCategory.ExternalContent.Posts[section].find(
                        (oldPost) => oldPost.value == newPost.value
                    )
            )
            let newTags = newCategory.ExternalContent.Tags[section].filter(
                (newTag) =>
                    !oldCategory.ExternalContent.Tags[section].find(
                        (oldTag) => oldTag.value == newTag.value
                    )
            )
            newPosts.forEach((post) => {
                CategoryExternalContentAdded.push({
                    Source: 'WP',
                    Type: 'Post',
                    Value: post.id,
                    CategoryId: categoryId,
                    Section: section,
                    OrderBy: post.OrderBy,
                })
            })
            newTags.forEach((tag) => {
                CategoryExternalContentAdded.push({
                    Source: 'WP',
                    Type: 'Tag',
                    Value: tag.value,
                    CategoryId: categoryId,
                    Section: section,
                })
            })
        })

        let CategoryExternalContentDeleted = []
        Sections.forEach((section) => {
            let oldTags = []
            let oldPosts = []
            if (newCategory?.Technologies && oldCategory?.Technologies) {
                oldTags = oldCategory.ExternalContent.Tags[section].filter(
                    (oldTag) =>
                        !newCategory.ExternalContent.Tags[section].find(
                            (newTag) => oldTag.value == newTag.value
                        )
                )
                oldPosts = oldCategory.ExternalContent.Posts[section].filter(
                    (oldPost) =>
                        !newCategory.ExternalContent.Posts[section].find(
                            (newPost) => oldPost.value == newPost.value
                        )
                )
            }

            oldTags.forEach((tag) => {
                CategoryExternalContentDeleted.push({
                    Source: 'WP',
                    Type: 'Tag',
                    Value: tag.value,
                    CategoryId: categoryId,
                    Section: section,
                })
            })
            oldPosts.forEach((post) => {
                CategoryExternalContentDeleted.push({
                    Source: 'WP',
                    Type: 'Post',
                    Value: post.value,
                    CategoryId: categoryId,
                    Section: section,
                    OrderBy: post.OrderBy,
                })
            })
        })

        let CategoryExternalContentChanged = []
        Sections.forEach((section) => {
            let changedPosts = []
            if (newCategory?.Technologies && oldCategory?.Technologies) {
                changedPosts = newCategory.ExternalContent.Posts[section].filter((newPost) =>
                    oldCategory.ExternalContent.Posts[section].find(
                        (oldPost) =>
                            oldPost.value == newPost.value && oldPost.OrderBy !== newPost.OrderBy
                    )
                )
            }

            changedPosts.forEach((post) => {
                CategoryExternalContentChanged.push({
                    Source: 'WP',
                    Type: 'Post',
                    Value: post.value,
                    CategoryId: categoryId,
                    Section: section,
                    OrderBy: post.OrderBy,
                })
            })
        })

        let newPreferredVendors = newCategory.PreferredVendors.filter(
            (newVendor) =>
                !oldCategory.PreferredVendors.find(
                    (oldVendor) => oldVendor.VENDID == newVendor.VENDID
                )
        )
        let CategoryPreferredVendorsAdded = newPreferredVendors.map((vendor) => ({
            CategoryId: categoryId,
            VendorId: vendor.VENDID,
            OrderBy: vendor.OrderBy,
        }))

        let oldPreferredVendors = []
        if (newCategory?.Technologies && oldCategory?.Technologies) {
            oldPreferredVendors = oldCategory.PreferredVendors.filter(
                (oldVendor) =>
                    !newCategory.PreferredVendors.find(
                        (newVendor) => oldVendor.VENDID == newVendor.VENDID
                    )
            )
        }

        let CategoryPreferredVendorsDeleted = oldPreferredVendors.map((vendor) => ({
            CategoryId: categoryId,
            VendorId: vendor.VENDID,
            OrderBy: vendor.OrderBy,
        }))

        let CategoryPreferredVendorsChanged = []
        let changedVendors = []
        if (newCategory?.Technologies && oldCategory?.Technologies) {
            changedVendors = newCategory.PreferredVendors.filter((newVendor) =>
                oldCategory.PreferredVendors.find(
                    (oldVendor) =>
                        oldVendor.VENDID == newVendor.VENDID &&
                        oldVendor.OrderBy !== newVendor.OrderBy
                )
            )
        }

        changedVendors.forEach((vendor) => {
            CategoryPreferredVendorsChanged.push({
                CategoryId: categoryId,
                VendorId: vendor.VENDID,
                OrderBy: vendor.OrderBy,
            })
        })

        let CategoryAttributeAdded = []
        let CategoryAttributeDeleted = []
        let CategoryAttributeChanged = []

        // Grid Column logic comes after so keeping pointers to the changes in case they need updating as well
        let pointersToChanges = {}
        let attributeChanges = partsRef.current.attributes
        attributeChanges.map((ele) => {
            let { state, ...attributeInfo } = ele
            if (state === 'ADDED' || state === 'CHANGED') {
                // changes since attribute might be reused from another category
                let originalAttribute = attributeInfo.originalAttribute
                let attributeChanges = {}
                for (let key in attributeInfo) {
                    // I made up Technologies field for other table
                    if (
                        key !== 'originalAttribute' &&
                        attributeInfo[key] !== originalAttribute[key]
                    ) {
                        attributeChanges[key] = attributeInfo[key]
                        attributeChanges.Item = attributeInfo.Item
                    }
                }
                if (state === 'CHANGED') {
                    CategoryAttributeChanged.push(attributeChanges)
                    pointersToChanges[attributeChanges.Item] = attributeChanges
                }
                if (state === 'ADDED') {
                    CategoryAttributeAdded.push(attributeChanges)
                    pointersToChanges[attributeChanges.Item] = attributeChanges
                }
            } else if (state === 'DELETED') {
                CategoryAttributeDeleted.push({ Item: attributeInfo.Item })
            }
        })

        partsRef.current.columns.forEach((attribute, i) => {
            if (!attribute.GridColumn) {
                return
            }
            // -5 because 6 non attribute columns and want GridColumn to start at 1
            if (attribute.orderIndex !== i && attribute.GridColumn !== attribute.orderIndex - 5) {
                let change = pointersToChanges[attribute.Item]
                if (!change) {
                    CategoryAttributeChanged.push({
                        Item: attribute.Item,
                        GridColumn: attribute.orderIndex - 5,
                    })
                } else {
                    change.GridColumn = attribute.orderIndex - 5
                }
            }
        })

        let pointerToInvtChanges = {}
        let InventoryMasterChanged = []

        let InventoryAttributeDeleted = []
        let InventoryAttributeAdded = []
        let InventoryAttributeChanged = []

        let loadedParts = {}

        // format loaded parts to look like loaded ica.InventoryCategoryAttribute
        if (partsRef.current.loadedParts) {
            Object.keys(partsRef.current.loadedParts).forEach((key) => {
                let newLoadedPart = { 'Part Number': key }
                partsRef.current.loadedParts[key].forEach((attribute) => {
                    newLoadedPart[attribute.Title] = attribute.AttributeValue
                })
                loadedParts[key] = newLoadedPart
            })
        }
        let columns = partsRef.current.columns
        let changedParts = Object.keys(partsRef.current.changedParts)
        if (changedParts.length > 0) {
            let newGrid = partsRef.current.grid
            for (let i = 0; i < changedParts.length; i++) {
                let partNumber = changedParts[i]
                if (partNumber.trim().length === 0) {
                    continue
                }
                let newPart = newGrid.find((x) => x['Part Number'] === partNumber)
                let oldPart = ica.InventoryCategoryAttribute.find(
                    (x) => x['Part Number'] === partNumber
                )
                // if loaded newPart add it to the category
                if (!oldPart && loadedParts[partNumber]) {
                    oldPart = loadedParts[partNumber]
                    let newRecord = pointerToInvtChanges[partNumber] || { PartNumber: partNumber }
                    let existing = pointerToInvtChanges[partNumber]
                    newRecord.CategoryId = categoryId
                    pointerToInvtChanges[partNumber] = newRecord
                    !existing && InventoryMasterChanged.push(newRecord)
                }
                //changed
                if (newPart && oldPart) {
                    columns.forEach((attribute, k) => {
                        // PartNumber, Mkt

                        if (attribute.Title === 'Part Number') return
                        else if (attribute.Title === 'Mkt') {
                            let newValue = newPart[attribute.Title]
                            let oldValue = oldPart[attribute.Title]
                            if (newValue !== oldValue) {
                                let newRecord = pointerToInvtChanges[partNumber] || {
                                    PartNumber: partNumber,
                                }
                                newRecord.MarketingCode = newValue.trim()
                                let existing = pointerToInvtChanges[partNumber]
                                pointerToInvtChanges[partNumber] = newRecord
                                !existing && InventoryMasterChanged.push(newRecord)
                            }
                            return
                        } else if (attribute.Title === 'Description') {
                            let newValue = newPart[attribute.Title]
                            let oldValue = oldPart[attribute.Title]
                            if (newValue !== oldValue) {
                                let newRecord = pointerToInvtChanges[partNumber] || {
                                    PartNumber: partNumber,
                                }
                                let existing = pointerToInvtChanges[partNumber]
                                newRecord.Description = newValue.trim()
                                pointerToInvtChanges[partNumber] = newRecord
                                !existing && InventoryMasterChanged.push(newRecord)
                            }
                            return
                        } else if (attribute.Title === 'Web Enabled') {
                            let newValue = newPart[attribute.Title]
                            let oldValue = oldPart[attribute.Title]
                            if (newValue !== oldValue) {
                                let newRecord = pointerToInvtChanges[partNumber] || {
                                    PartNumber: partNumber,
                                }
                                let existing = pointerToInvtChanges[partNumber]
                                newRecord.WebEnabled = newValue
                                pointerToInvtChanges[partNumber] = newRecord
                                !existing && InventoryMasterChanged.push(newRecord)
                            }
                            return
                        } else if (attribute.Title === 'Data Quality Index') {
                            let newValue = newPart[attribute.Title]
                            let oldValue = oldPart[attribute.Title]
                            if (newValue !== oldValue && newValue !== 'False') {
                                let newRecord = pointerToInvtChanges[partNumber] || {
                                    PartNumber: partNumber,
                                }
                                let existing = pointerToInvtChanges[partNumber]
                                newRecord.DataQualityIndex = newValue
                                pointerToInvtChanges[partNumber] = newRecord
                                !existing && InventoryMasterChanged.push(newRecord)
                            }
                            return
                        } else if (attribute.Title === 'Data Quality Last Reviewed') {
                            return
                        } else if (attribute.Title === 'Image') {
                            let newValue = newPart[attribute.Title]
                            // length check becuase False and True come as strings
                            if (newValue !== undefined && typeof newValue === 'string') {
                                let newRecord = pointerToInvtChanges[partNumber] || {
                                    PartNumber: partNumber,
                                }
                                let existing = pointerToInvtChanges[partNumber]
                                newRecord.Image = newValue.trim()
                                pointerToInvtChanges[partNumber] = newRecord
                                !existing && InventoryMasterChanged.push(newRecord)
                            }
                            return
                        }

                        let newValue = newPart[attribute.Title]
                        let oldValue = oldPart[attribute.Title]
                        let item = attribute.Item
                        if (newValue !== oldValue) {
                            if (!oldValue && newValue !== '') {
                                // not Added
                                InventoryAttributeAdded.push({
                                    PartNumber: partNumber,
                                    Item: item,
                                    AttributeValue: newValue,
                                })
                            } else if (oldValue && newValue === '') {
                                InventoryAttributeDeleted.push({
                                    PartNumber: partNumber,
                                    Item: item,
                                })
                            } else if (oldValue && newValue !== '') {
                                InventoryAttributeChanged.push({
                                    PartNumber: partNumber,
                                    Item: item,
                                    AttributeValue: newValue,
                                })
                            }
                        }
                    })
                } else if (oldPart) {
                    // just remove from the category -- don't apply attribute changes
                    InventoryMasterChanged.push({ PartNumber: partNumber, CategoryId: -1 })
                } else {
                    console.warn(`Error for ${partNumber}`)
                }
            }
        }

        let payload = {
            CategoryChanged,
            CategoryTechnologyAdded,
            CategoryTechnologyDeleted,
            CategoryPreferredVendorsAdded,
            CategoryPreferredVendorsDeleted,
            CategoryPreferredVendorsChanged,
            CategoryAttributeAdded,
            CategoryAttributeDeleted,
            CategoryAttributeChanged,
            InventoryMasterChanged,
            InventoryAttributeDeleted,
            InventoryAttributeAdded,
            InventoryAttributeChanged,
            CategoryExternalContentAdded,
            CategoryExternalContentDeleted,
            CategoryExternalContentChanged,
        }

        for (let key in payload) {
            if (key === 'CategoryChanged') {
                if (Object.keys(CategoryChanged).length === 0) {
                    delete payload[key]
                }
            } else {
                if (payload[key].length === 0) {
                    delete payload[key]
                }
            }
        }
        return payload
    }
    const handleDiscard = () => {
        partsRef.current = {
            attributes: [],
            columns: [],
            grid: [],
            changedParts: {},
            loadedParts: {},
        }
        categoryRef.current = null
        setGrid([[]])
        setGrid2([{}])
    }
    const handleCatSave = (categoryId) => {
        let payload = getCatSavePayload(categoryId)
        if (Object.entries(payload).every((ele) => Object.keys(ele[1]).length === 0)) {
            alert('No changes were made')
            return
        }
        let save_url = CAT_SAVE_URL + currentCategory
        fetch(save_url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((resp) => {
                if (resp.ok) return resp.text()
                else if (resp.status > 399 && resp.status < 500) {
                    throw resp.text()
                } else {
                    throw new Error('Bad response')
                }
            })
            .then((resp) => {
                partsRef.current = {
                    changedParts: {},
                    attributes: [],
                    columns: [],
                    loadedParts: {},
                }
                // if success just set node instead of re getting
                // treeInfo[categoryId].node = JSON.parse(JSON.stringify(categoryRef.current))
                setAlertText(SAVE_SUCCESSFUL_TEXT)
                setRefresh([])
                setRefreshTree([])
            })
            .catch(async (e) => {
                let message = await e
                alert(message)
            })
    }

    const treeRefreshTree = React.useCallback(() => setRefreshTree([]), [])
    const treeSetCategory = React.useCallback((newCat) => {
        setCurrentCategory(newCat)
        setGrid([[]])
    }, [])
    return (
        <div
            onDrop={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}
            className='categoryForms'
        >
            <div className='mainContainer'>
                <Splitter
                    panes={nestedSplitterInfo}
                    orientation={'horizontal'}
                    onChange={onNestedSplitterChange}
                    style={{}}
                >
                    <div className='pane-content' style={{ height: '100%', overflow: 'hidden' }}>
                        {treeInfo && (
                            <TreePanel
                                treeInfo={treeInfo2}
                                treeDict={treeInfo}
                                setTreeInfo={setTreeInfo2}
                                treeReloaded={treeReloaded}
                                currentCategory={currentCategory}
                                setCurrentCategory={treeSetCategory}
                                canChangeCategory={canChangeCategory}
                                openSaveDialog={(newCatId, changeCallback) =>
                                    setCurrentModal(
                                        <SaveDialog
                                            handleSave={() => {
                                                handleCatSave(currentCategory)
                                                changeCallback()
                                                setCurrentModal(null)
                                            }}
                                            handleClose={() => setCurrentModal(null)}
                                            handleDiscard={() => {
                                                handleDiscard()
                                                setCurrentCategory(newCatId)
                                                changeCallback()
                                                setCurrentModal(null)
                                            }}
                                        />
                                    )
                                }
                                refreshTree={treeRefreshTree}
                                setAlertText={setAlertText}
                                canWrite={canWrite}
                            />
                        )}
                    </div>
                    <Splitter
                        panes={splitterInfo}
                        onChange={onSplitterChange}
                        orientation={'vertical'}
                    >
                        <div className='pane-content' style={{ overflow: 'visible' }}>
                            {currentCategory && (
                                <CategoryDetail
                                    treeInfo={treeInfo}
                                    currentCategory={
                                        currentCategory && treeInfo[currentCategory].node
                                    }
                                    setCurrentCategory={setCurrentCategory}
                                    onKeyChange={(text) =>
                                        (treeInfo[currentCategory].CategoryId = text)
                                    }
                                    categoryRef={categoryRef}
                                    handleCatSave={handleCatSave}
                                    canWrite={canWrite}
                                    canChangeCategory={canChangeCategory}
                                />
                            )}
                        </div>
                        {currentCategory && loading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%',
                                }}
                            >
                                <div
                                    className='k-icon k-i-loading'
                                    style={{ fontSize: '10vh' }}
                                ></div>
                            </div>
                        ) : (
                            <div className='partDetailPanel'>
                                {currentCategory &&
                                    treeInfo[currentCategory].children.length === 0 && (
                                        <PartDetail
                                            currentCategory={
                                                currentCategory &&
                                                treeInfo[currentCategory].children.length === 0 &&
                                                currentCategory
                                            }
                                            canWrite={canWrite}
                                            attributes={attributes}
                                            grid={grid2}
                                            setGrid={setGrid2}
                                            ica={ica}
                                            partsRef={partsRef}
                                            handleCatSave={handleCatSave}
                                        />
                                    )}
                            </div>
                        )}
                    </Splitter>
                </Splitter>
            </div>
            <div>
                <Snackbar
                    open={alertText}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    onClose={() => setAlertText(false)}
                >
                    <Alert severity='success'>{alertText}</Alert>
                </Snackbar>
            </div>
            {currentModal}
        </div>
    )
}

export default CategoryForms
